/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './work-flow-protocol-log.reducer';

export const WorkFlowProtocolLogDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workFlowProtocolLogEntity = useAppSelector(state => state.workFlowProtocolLog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workFlowProtocolLogDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.detail.title">WorkFlowProtocolLog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.id">Id</Translate>
            </span>
          </dt>
          <dd>{workFlowProtocolLogEntity.id}</dd>
          <dt>
            <span id="encounterId">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.encounterId">Encounter Id</Translate>
            </span>
            <UncontrolledTooltip target="encounterId">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.encounterId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.encounterId}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.notes">Notes</Translate>
            </span>
            <UncontrolledTooltip target="notes">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.notes" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.notes}</dd>
          <dt>
            <span id="completedById">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.completedById">Completed By Id</Translate>
            </span>
            <UncontrolledTooltip target="completedById">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.completedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.completedById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolLogEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.encounterType">Encounter Type</Translate>
          </dt>
          <dd>{workFlowProtocolLogEntity.encounterType ? workFlowProtocolLogEntity.encounterType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.protocol">Protocol</Translate>
          </dt>
          <dd>{workFlowProtocolLogEntity.protocol ? workFlowProtocolLogEntity.protocol.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.completedByType">Completed By Type</Translate>
          </dt>
          <dd>{workFlowProtocolLogEntity.completedByType ? workFlowProtocolLogEntity.completedByType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/work-flow-protocol-log" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/work-flow-protocol-log/${workFlowProtocolLogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkFlowProtocolLogDetail;
